export enum ESystemUser {
    System = -1,
    REST = -2,
    CLOCKODO = -3,
    ZEP = -4,
    SLACK = -5,
}
